import React from 'react';
import { Controller } from 'react-hook-form';
import { Control, Field, Label, Textarea } from 'components/UIComponents/Form';
import ValidationError from 'components/FormControls/ValidationError';
import { useTranslation } from 'react-i18next';
import {
  BLACK_BOX_UPLOAD_DESCRIPTION_MAX_LENGTH,
  NO_WHITESPACE_REGEX,
} from 'utils/constants/formConstants';

export default ({ name, control, errors }) => {
  const { t } = useTranslation();

  return (
    <Field>
      <Control>
        <Label required htmlFor={name}>
          {t('datagate.external.blackBox.fileUpload.form.explanation.label')}
        </Label>
        <Controller
          as={
            <Textarea
              id={name}
              placeholder={t(
                'datagate.external.blackBox.fileUpload.form.explanation.placeholder',
                {
                  length: BLACK_BOX_UPLOAD_DESCRIPTION_MAX_LENGTH,
                }
              )}
              maxLength="500"
            />
          }
          rules={{
            required: t(
              'datagate.external.blackBox.fileUpload.form.explanation.required'
            ),
            pattern: {
              value: NO_WHITESPACE_REGEX,
              message: t(
                'datagate.external.blackBox.fileUpload.form.explanation.required'
              ),
            },
          }}
          name={name}
          control={control}
        />
      </Control>
      <ValidationError name={name} errors={errors} />
    </Field>
  );
};
